import React, { useEffect, useState } from "react";
import { MdFilterListAlt, MdOutlineCancel } from "react-icons/md";
import { userRole, userUid } from "../../utils/storage";
import UserService from "../../GlobalSetupComponents/Services/UserService";
import {
  managementDepartmentLabel,
  salesDepartmentLabel,
} from "../../GlobalSetupComponents/Enum/DepartmentEnum";
import TeamService from "../../GlobalSetupComponents/Services/TeamService";
import CustomSelect from "../../components/common/CustomSelect";
import OverallSittingList from "./OverallSittingList";
import ReusableSittingForm from "./ReusableSittingForm";
import { formatToIndianDate, formatDate, fromInputDate } from "../../utils/dateFormatter";
import Header from "../Header/Header";
import CustomHeading from "../../components/common/CustomHeading";
import OverallSittingFilter from "./OverallSittingFilter";
import SittingService from "../Service/SittingService";
import CustomModel from "../../components/common/CustomModel";
import ConfirmationModal from "../../components/shareableContainer/ConfirmationModal";
import { showErrorToast, showSuccessToast } from "../../components/Constant/Notification";
import { ToastContainer } from "react-toastify";
import SittingStatusModal from "./SittingStatusModal";

const OverallSittingPage = () => {
  const [activeTab, setActiveTab] = useState(0);
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const [isSittingFormOpen, setIsSittingFormOpen] = useState(false);
  const [selectedSittingData, setSelectedSittingData] = useState(null);
  
  // Get today's date in YYYY-MM-DD format to avoid timezone issues
  const getTodayFormatted = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };
  
  const todayFormatted = getTodayFormatted();
  const today = new Date(todayFormatted + 'T12:00:00'); // Set to noon to avoid timezone issues

  const [startDate, setStartDate] = useState(today);
  const [endDate, setEndDate] = useState(today);
  const [filterStartDate, setFilterStartDate] = useState(today);
  const [filterEndDate, setFilterEndDate] = useState(today);
  const [startType, setStartType] = useState("");
  const [teams, setTeams] = useState([{ name: "All Team", id: "All Team" }]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [properties, setProperties] = useState([
    { name: "All Property", id: "All Property" },
  ]);
  const [users, setUsers] = useState([]);
  const [selectedTeam, setSelectedTeam] = useState(null);
  const [tempSelected, setTempSelected] = useState("");
  const [areaType, setAreaType] = useState("sqft");
  const [rating, setRating] = useState(0);
  const [feedback, setFeedback] = useState("");
  const [negotiatedAmount, setNegotiatedAmount] = useState(0);
  const [advanceAmount, setAdvanceAmount] = useState(0);
  const [cancellationReason, setCancellationReason] = useState("");
  const [formData, setFormData] = useState({
    stage : "",
    sittingTitle: "",
    sittingSpot: "",
    isCompleted :"",
    primarySittingPerson: null,
    secondarySittingPerson: null,
    meetingPersonType: "",
    meetingPersonName: "",
    sittingDate: "",
    sittingTime: "",   
    otherNotes: "",
    status: "",
    negotiatedAreaType : "",
    negotiatedAmount : "",
    advanceAmount : "",
    feedback : "", 
    cancellationReason : ""
  });

  const [isCompleted, setIsCompleted] = useState(false);
  const [isCancelled, setIsCancelled] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        let response = {};
        if (userRole !== "BOD") {
          response = await TeamService.getDepartmentTeamList({
            department: salesDepartmentLabel,
          });
        }
        const data = response.data || [];
        setTeams([{ name: "All Team", id: "All Team" }, ...data]);

        const userResponse = await UserService.getDepartmentWithTeamMembers({
          departmentNames: [managementDepartmentLabel, salesDepartmentLabel],
          teamId: selectedTeam,
        });
        const userData = userResponse.data?.users || [];
        setUsers(
          userData.map((user) => ({
            label: user.name,
            value: user.id,
            role: user.role,
          }))
        );
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    })();
  }, [selectedTeam]);

  const handleApplyFilter = () => {
    setIsFilterOpen(false);
    setFilterStartDate(startDate);
    setFilterEndDate(endDate);
    setRefreshTrigger((prev) => prev + 1);
  };

  const clearFilters = () => {
    setSelectedUser(null);
    setSelectedTeam(null);
    setStartDate(today);
    setEndDate(today);
    setFilterStartDate(today);
    setFilterEndDate(today);
    setRefreshTrigger((prev) => prev + 1);
  };

  const handleSittingFormOpen = async (sittingData = null) => {
    setSelectedSittingData(sittingData);


    const sitting = sittingData || {};
       try{
   
         const userDetails = await SittingService.getSittingById(sitting.propertyId , sitting.id);
     
         const data = userDetails.data?.data || {};
         setFormData({
            stage : data.currentStatus || "",
            isCompleted : data.isCompleted || "",
           sittingTitle: data.title || "",
           sittingSpot: data.location || "",
           primarySittingPerson: data.primarySittingPerson ? {
             value: data.primarySittingPerson.id,
             label: data.primarySittingPerson.name
           } : "",
           secondarySittingPerson: data.secondarySittingPerson ? {
             value: data.secondarySittingPerson.id,
             label: data.secondarySittingPerson.name
           } : "",
           meetingPersonName: data.meetingPersonName || "",
           meetingPersonType: data.meetingPersonType || "",
           sittingDate : data.sittingDate || "",
           sittingTime : data.sittingTime || "",
           otherNotes: data.notes || "",
           negotiatedAreaType : data.negotiatedAreaType || "",
           negotiatedAmount : data.negotiatedAmount || "",
           advanceAmount : data.advanceAmount || "",
           feedback : data.feedback || "", 
           cancellationReason : data.cancellationReason || ""
         });
       }catch(error){
         console.error("Error fetching sitting details:", error);
       }
      
    setIsSittingFormOpen(true);
  };

  const handleSittingFormClose = () => {
    setIsSittingFormOpen(false);
    setSelectedSittingData(null);
    setFormData({
      sittingTitle: "",
      sittingSpot: "",
      primarySittingPerson: null,
      secondarySittingPerson: null,
      meetingPersonType: "",
      meetingPersonName: "",
      sittingDateTime: "",
      otherNotes: "",
      status: "",
    });
  };

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

    const handleValidation = () => {
      if(!formData.sittingTitle?.trim()) {
        showErrorToast("Sitting Title is required");
        return false;
      }
      if(!formData.sittingDate) {
        showErrorToast("Sitting Date is required");
        return false;
      }
      if(!formData.sittingTime) {
        showErrorToast("Sitting Time is required");
        return false;
      }
      if(!formData.sittingSpot?.trim()) {
        showErrorToast("Sitting Spot is required");
        return false;
      }
      if(!formData.primarySittingPerson) {
        showErrorToast("Primary Sitting Person is required");
        return false;
      }
  
      return true;
  
    }


  const handleFormSubmit = async (status) => {
    if(status === "COMPLETED"){
      setIsCompleted(true);
      setIsSittingFormOpen(false);

      return;
    }
    if(status === "CANCELLED"){
      setIsCancelled(true);
      setIsSittingFormOpen(false);
      return;
    }

    if (!handleValidation()) {
      return;
    }

    try {
      const body = {
        sittingId: selectedSittingData?.id || "",
        title: formData.sittingTitle,
        sittingDate: (formData.sittingDate), 
        sittingTime: formData.sittingTime || "",
        location: formData.sittingSpot,
        primarySittingPerson: formData.primarySittingPerson?.value || "",
        secondarySittingPerson: formData.secondarySittingPerson?.value || "",
        meetingPersonType: formData.meetingPersonType,
        meetingPersonName: formData.meetingPersonName,
        notes: formData.otherNotes,
        modifiedById: userUid,
        isCompleted: status,
      };

 
      let response;
     
        response = await SittingService.updateSitting(body);
      

      if (response.data) {
        console.log(
          selectedSittingData?.sittingId
            ? "Sitting updated successfully"
            : "Sitting created successfully",
          response.data
        );
        setIsSittingFormOpen(false);
        setSelectedSittingData(null);
        setFormData({
          sittingTitle: "",
          sittingSpot: "",
          primarySittingPerson: null,
          secondarySittingPerson: null,
          meetingPersonType: "",
          meetingPersonName: "",
          sittingDateTime: "",
          otherNotes: "",
          status: "",
        });
        setRefreshTrigger((prev) => prev + 1);
      }
    } catch (error) {
      console.error(
        selectedSittingData?.sittingId ? "Error updating sitting:" : "Error creating sitting:",
        error
      );
    }
  };

  const handleUpdateSittingStatus = async (sittingId, status) => {

    try{
        let body = {};
      if(status === "CANCELLED" ){
       
        body = {
          sittingId : sittingId || "",
          status : status || "",
          modifiedById : userUid,
          cancellationReason : cancellationReason || ""
        }
      }
      else if(status === "COMPLETED"){
       
        body = {
                     sittingId : sittingId || "",
                     status : status || "",
                     modifiedById : userUid,
                     areaType : areaType?.value || "sqft",
                     negotiatedAmount : Number(negotiatedAmount) || 0,
                     feedback : feedback || "",
                     advanceAmount : Number(advanceAmount) || 0,
        }
      }

      const response  = await SittingService.sittingUpdateStatus(body);
      if(response.data){
        setIsCancelled(false);
        setIsCompleted(false);
        setCancellationReason("");
        setAreaType("sqft");
        setRating(0);
        setFeedback("");
        setNegotiatedAmount(0);
        setAdvanceAmount(0);
        setRefreshTrigger((prev) => prev + 1);
      }
      showSuccessToast("Sitting status updated successfully.");
      

    }catch(error){
      console.error("Error updating sitting status:", error);
    }

  }

  const handleStatusUpdate = ()=>{
     setRefreshTrigger((prev) => prev + 1);
  }

  return (
    <div className="bg-appGrayBackground min-h-screen">
      <Header />
      <ToastContainer />  
      <div className="px-6 pt-28">
        <div className="flex justify-between items-center mb-6">
          <CustomHeading title="Overall Sitting" />
          <div className="flex items-center gap-4">
            {(filterStartDate || filterEndDate) && (
              <div className="flex items-center gap-2 px-3 py-1 rounded-full border border-customGreen bg-white text-customGreen text-sm transition-all duration-150">
                <span className="truncate">
                  Date: {formatToIndianDate(filterStartDate)} -{" "}
                  {formatToIndianDate(filterEndDate)}
                </span>
                <button
                  onClick={clearFilters}
                  className="text-customGreen hover:bg-customGreen hover:text-white rounded-full p-1 transition-all duration-150"
                  aria-label="Remove date filter"
                >
                  <MdOutlineCancel className="text-lg" />
                </button>
              </div>
            )}
            <button
              onClick={() => setIsFilterOpen(!isFilterOpen)}
              className="bg-white text-base font-medium w-[131px] h-[50px] rounded-[10px] flex items-center gap-3 text-customGreen py-2 px-4 hover:bg-appGreenHover transition duration-300"
            >
              Filters
              <MdFilterListAlt />
            </button>
          </div>
        </div>
        <div className="mt-6">
          <OverallSittingList
            activeTab={activeTab}
            startDate={filterStartDate}
            endDate={filterEndDate}
            selectedTeam={selectedTeam}
            setSelectedTeam={setSelectedTeam}
            selectedUser={selectedUser}
            setSelectedUser={setSelectedUser}
            refreshTrigger={refreshTrigger}
            onSittingFormOpen={handleSittingFormOpen}
          />
        </div>
      </div>
      <ReusableSittingForm
        visible={isSittingFormOpen}
        onHide={handleSittingFormClose}
        setFormData={setFormData}
        onSubmit={handleFormSubmit}
        formData={formData}
        onChange={handleFormChange}
        title="Sitting"
        sidebarWidth="600px"
        showAdvancedButtons={true}
        customButtonLogic={(formData) => {
          const isUpcomingOrNoUpdate = 
            formData.isCompleted === "No Update" || 
            formData.isCompleted === "Up Coming";
          
          return {
            showPrimaryButton: isUpcomingOrNoUpdate,
            showCompletedButton: isUpcomingOrNoUpdate,
            showCancelButton: isUpcomingOrNoUpdate,
          };
        }}
      />
      <OverallSittingFilter
        visible={isFilterOpen}
        onHide={() => setIsFilterOpen(false)}
        setEndDate={setEndDate}
        startDate={startDate}
        setStartDate={setStartDate}
        endDate={endDate}
        handleApplyFilter={handleApplyFilter}
        clearFilters={clearFilters}
        setStartType={setStartType}
        startType={startType}
      />
     <SittingStatusModal
  isCompletedOpen={isCompleted}
  setIsCompletedOpen={setIsCompleted}
  isCancelledOpen={isCancelled}
  setIsCancelledOpen={setIsCancelled}
  selectedSittingData={selectedSittingData}
  onStatusUpdate={handleStatusUpdate}
/>
      
    </div>
  );
};

export default OverallSittingPage;